import React, { Fragment, useState, useEffect } from "react";
import {
    Button,
    Modal,
} from "react-bootstrap";

import axios from "axios";
import { Progress } from "reactstrap";
import { getInstance } from '../config/token';
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode, getCountries } from 'react-phone-number-input/input'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import 'react-phone-number-input/style.css'

const prefix = process.env.REACT_APP_API_URL

const useStyles = makeStyles({
    paper: {
        fontWeight: "700",
        border: "1px solid #3D455A !important",
        borderRadius: "0.75rem !important"
    }
});

const AddSmsPopup = (props) => {

    const [phoneInputDisable, setPhoneInputDisable] = React.useState(false)
    const [country, setCountry] = useState(props && props.country ? props.country : "US")
    const [countryCode, setCountryCode] = useState(props && props.code ? props.code : "1")
    const [filePath, setFilePath] = useState([]);
    const [loading, setLoading] = useState(false);
    const [phone, setPhone] = useState(props && props.phone ? props.phone : "");
    const [file, setFile] = useState("");
    const [loaded, setLoader] = useState(0);
    const [message, setmessage] = useState("");
    const [fileName, setFileName] = useState([]);
    const [cameraModal, setCameraModal] = useState(false);
    const [contactList, setContactList] = useState([])

    const classes = useStyles();

    const setPhoneNumber = (phone) => {
        if (phone != undefined) {
            setPhone(phone)
        }
    }

    const setCountryData = (country) => {
        if (country != undefined) {
            setCountry(country)
            setCountryCode(getCountryCallingCode(country))
        }
    }

    const createSms = (type="send") => {
        // setErrMsg("")
        let errFlag = false;
        if (phone == "") {
            errFlag = true;
            toast.error("phone is required.", {
                position: "top-right",
            });
        } else if (phone.length < 4) {
            errFlag = true;
            toast.error("Phone can not be less than 4 digit.", {
                position: "top-right",
            });
        } else if (message == "") {
            errFlag = true;
            toast.error("Message is required.", {
                position: "top-right",
            });
        } else if (message.length > 5000) {
            errFlag = true;
            toast.error("Message can not be more than 5000 characters.", {
                position: "top-right",
            });
        }

        if (!errFlag) {
            let requestObj = {
                phone: phone,
                message: message,
                file: filePath,
                code: countryCode,
                country: country,
                type : type
            };
            setLoading(true)
            let config = getInstance('POST', `/api/create_sms`, requestObj);
            axios(config)
                .then((res) => {

                    closePopup()
                    setFileName([]);
                    setPhone("");
                    setmessage("");
                    setFile("");
                    if (props.type == 'sms') {
                        props.getTicketListSms()
                    }
                    //   getTicketListSms()
                    setFilePath([])
                    //   setSelected([])
                    setLoading(false)

                    toast.success("Sms Thread Successfully Created", {
                        position: "top-right",
                    });
                })
                .catch((err) => {
                    setLoading(false)
                    let msg = "Something went wrong!"
                    // setLoading(false)
                    if (err.response && err.response.data && err.response.data.message) {
                        msg = err.response.data.message
                    }
                    toast.error(msg, {
                        position: "top-right",
                    });
                });
        }
    };

    const maxSelectFile = (event) => {
        let files = event.target.files // create file object
        if (files.length > 3) {
            //  const msg = 'Only 3 images can be uploaded at a time'
            event.target.value = null // discard selected file
            toast.error("Only 2 files can be uploaded at a time.", {
                position: "top-right",
            });
            return false;

        }
        return true;

    }

    const checkFileSize = (event) => {
        let files = event.target.files
        let size = 5000000
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err += files[x].type + ' is too large, please pick a smaller file\n';
            }
        };
        if (err !== '') {
            event.target.value = null
            toast.error(err, {
                position: "top-right",
            });
            return false
        }

        return true;

    }

    const onFileChange = (e) => {
        // this.setState({ file: e.target.files[0] },() => {
        var mulFiles = e.target.files
        if (maxSelectFile(e) && checkFileSize(e)) {
            setLoading(true)
            setFile(mulFiles);
            const data = new FormData();
            for (var x = 0; x < mulFiles.length; x++) {
                data.append('file', mulFiles[x])
            }
            // data.append("file", e.target.files[0]);
            let config = getInstance('POST', `/api/upload`, data);
            // axios(config,
            //   onUploadProgress: (ProgressEvent) => {
            //     console.log("ProgressEvent", ProgressEvent)
            //     setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
            //   },
            // )
            axios.post(config.url, config.data, {
                headers: config.headers,
                onUploadProgress: (ProgressEvent) => {
                    setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
                },
            })

                .then((res) => {
                    // then print response status
                    setLoader(0);
                    setCameraModal(false);
                    let filePathArray = filePath
                    let fName = fileName
                    for (let i = 0; i < res.data.length; i++) {
                        // setFileName(res.data[i] && res.data[i].filename ? res.data[isNaN].filename : "");
                        let filepath = prefix + '/' + res.data[i].path
                        filePathArray.push(filepath)
                        // setFilePath(filepath)
                        fName.push(res.data[i].filename)
                    }
                    setFilePath(filePathArray)
                    setFileName(fName)
                    setLoading(false)
                })
                .catch((err) => {
                    setLoading(false)
                    console.log(err)
                });
        }
    };

    const onInputChange = (event, value, reason) => {
        if (value) {
            getData(value);
        } else {
            setContactList([]);
        }
    };

    const selectContact = (value) => {
        if (value) {
            setPhoneInputDisable(true)
            setPhone(value.phone)
            setCountry(value.country)
            setCountryCode(value.code)
        } else {
            setPhoneInputDisable(false)
        }
    }

    const getData = (searchTerm) => {
        let reqObj = {
            search: searchTerm,
        }
        let config = getInstance('POST', `/api/search_contacts`, reqObj);
        axios(config)
            .then((res) => {
                let contact = []
                if (res.data && res.data.rows) {
                    for (let i = 0; i < res.data.rows.length; i++) {
                        contact.push({ id: res.data.rows[i].id, label: res.data.rows[i].first_name && res.data.rows[i].last_name ? res.data.rows[i].first_name + " " + res.data.rows[i].last_name + " : " + res.data.rows[i].phone : res.data.rows[i].phone, phone: res.data.rows[i].phone, code: res.data.rows[i].calling_code, country: res.data.rows[i].country_code })
                    }
                }
                setContactList(contact)
            })
            .catch((err) => {
            })
    };

    const closePopup = () => {
        props.closeSmsPopup()
        setPhone("")
        setCountry("US")
        setCountryCode("1")
        setFileName([])
    }

    return (
        <Fragment>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <Modal enforceFocus={false} className="modal fade" show={props.newEvent}>
                <div className="">
                    <div className="modal-header">
                        <h5 className="modal-title">Add SMS</h5>
                        <Button
                            variant=""
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            onClick={() => closePopup()}
                        >
                            <span>×</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <form
                            className="comment-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                // setNewEvent(false);
                            }}
                        >
                            <div>
                                <div className="form-group">
                                    {props.type != 'contact' ?
                                        <div className="form-group">
                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={contactList}
                                                onInputChange={onInputChange}
                                                getOptionLabel={(option) => option.label}
                                                // style={{ border: "1px solid #3D455A", borderRadius: "0.75rem" }}
                                                classes={{ paper: classes.paper }}
                                                onChange={(event, value) => selectContact(value)}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Search Contact..." variant="outlined" />
                                                )}
                                            />
                                        </div>
                                        : ""}
                                    <div className="form-group">
                                        <label className="text-black font-w500"
                                            style={{ display: "block" }}>Phone Number</label>
                                        <PhoneInput
                                            // international
                                            disabled={phoneInputDisable}
                                            defaultCountry="US"
                                            placeholder="Enter phone number"
                                            value={phone}
                                            onChange={(e) => setPhoneNumber(e)}
                                            onCountryChange={(e) => setCountryData(e)} />
                                    </div>

                                    <label className="text-black font-w500">Message</label>
                                    <textarea
                                        name="message"
                                        id="textarea"
                                        cols={30}
                                        rows={5}
                                        maxLength={1500}
                                        className="form-control form-border-color"
                                        // placeholder="Please enter sms message"
                                        defaultValue={""}
                                        required
                                        onChange={(e) => setmessage(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <button
                                        // to="/app-profile"
                                        disabled={loading}
                                        className="btn btn-primary light px-3 "
                                        data-toggle="modal"
                                        data-target="#cameraModal"
                                        type="button"
                                        onClick={() => setCameraModal(true)}
                                    >
                                        <i className="fa fa-camera m-0" />
                                        {" Upload File "}
                                    </button>
                                    {fileName.map(function (name, j) {
                                        return (
                                            <div>
                                                {name}
                                                <br />
                                            </div>
                                        );
                                    })}
                                    {/* {fileName} */}
                                </div>
                                {/* Modal */}
                                <Modal
                                    show={cameraModal}
                                    // onHide={() => this.setState({ cameraModal: false })}
                                    className="modal fade"
                                    id="cameraModal"
                                >
                                    <div className="">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Upload images</h5>
                                            <button
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                onClick={() => setCameraModal(false)}
                                            >
                                                <span>×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">Upload</span>
                                                </div>
                                                <div className="custom-file ">
                                                    <input
                                                        type="file"
                                                        name="file"
                                                        multiple
                                                        className="custom-file-input"
                                                        onChange={(e) => onFileChange(e)}
                                                    />
                                                    <label className="custom-file-label form-border-color">
                                                        Choose file
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <Progress max="100" color="success" value={loaded}>
                                                    {Math.round(loaded, 2)}%
                                                </Progress>
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                                <div className="form-group" style={{ textAlign: "center" }}>
                                    <input
                                        disabled={loading}
                                        style={{marginRight : "10px"}}
                                        type="submit"
                                        value="Send SMS"
                                        className="btn btn-primary"
                                        onClick={() => createSms()}
                                    />

                                    <input
                                        disabled={loading}
                                        type="submit"
                                        value="Send & Complete"
                                        className="btn btn-primary"
                                        onClick={() => createSms("complete")}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </Fragment>
    )

}

export default AddSmsPopup;